import { IRecognitionFilterParams } from 'services/Recognition/types';
import ModalComponent from '../../../../../components/ModalComponent';
import DropdownV2 from 'components/DropdownComponentV2';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

interface RecognitionFilterModalProps {
  isOpen: boolean;
  onClose: () => void;
  currentFilter: IRecognitionFilterParams; 
  onFilter: (val: Partial<IRecognitionFilterParams>) => void;
}

const RecognitionFilterModal = ({
  isOpen,
  onClose,
  currentFilter,
  onFilter,
}: RecognitionFilterModalProps) => {
  const { t } = useTranslation(); 

  const faceOptions = useMemo(() => [
    { label: t('recognitionPage.modalEditFace.typesOfResponsible.student'), value: 'StudentRecognitionEntity' },
    { label: t('recognitionPage.modalEditFace.typesOfResponsible.responsible'), value: 'ResponsibleRecognitionEntity' },
    { label: t('recognitionPage.modalEditFace.typesOfResponsible.general'), value: 'GeneralRecognitionEntity' },
    { label: t('recognitionPage.modalEditFace.typesOfResponsible.customer'), value: 'CostumerRecognitionEntity' },
  ], [t]);

  const temporaryOptions = useMemo(() => [
    { label: t('recognitionPage.modalEditFace.filterTemporary'), value: 'TEMPORARY' },
  ], [t]);

  const statusOptions = useMemo(() => [
    { label: t('recognitionPage.modalEditFace.filterActive') || 'Ativos', value: 'TRUE' },
    { label: t('recognitionPage.modalEditFace.filterDisabled') || 'Desativados', value: 'FALSE' },
  ], [t]);

 const discriminatorValue = currentFilter.discriminator || '';
  const temporaryValue = currentFilter.temporary === true ? 'TEMPORARY' : '';
  const statusValue = currentFilter.isActive === true ? 'TRUE' : (currentFilter.isActive === false ? 'FALSE' : '');
  
  return (
    <ModalComponent
      isOpen={isOpen}
      onClose={onClose}
      title={t('recognitionPage.modalEditFace.recognitionFilter')}
    >
      <DropdownV2
        label={t('recognitionPage.modalEditFace.typesOfResponsible.faceType')}
        onChange={(val) => onFilter({ ...currentFilter, discriminator: val || undefined })} // Restaura o undefined pro state se for vazio
        valueField={'value'}
        options={faceOptions}
        labelField={'label'}
        value={discriminatorValue}
      />

      <DropdownV2
        label={t('recognitionPage.modalEditFace.filterCondition') || 'Tipo de Vinculo'}
        onChange={(val) => onFilter({ ...currentFilter, temporary: val === 'TEMPORARY' ? true : undefined })}
        valueField={'value'}
        options={temporaryOptions}
        labelField={'label'}
        value={temporaryValue}
      />

      <DropdownV2
        label={t('recognitionPage.modalEditFace.status') || 'Status'}
        onChange={(val) => {
          onFilter({ 
              ...currentFilter, 
              isActive: val === 'TRUE' ? true : (val === 'FALSE' ? false : undefined) 
          });
        }}
        valueField={'value'}
        options={statusOptions}
        labelField={'label'}
        value={statusValue}
      />

    </ModalComponent>
  );
};

export default RecognitionFilterModal;
